import { useState, useEffect, useCallback } from 'react';

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export function useLeadsPlusAgentData(initialData) {
  const [leadsPlusAgent, setLeadsPlusAgent] = useState(initialData ?? '');

  const setDataToSessionStorage = useCallback((data) => {
    sessionStorage.setItem('agentData', JSON.stringify(data));
  }, []);

  const getDataFromSessionStorage = useCallback(() => {
    return JSON.parse(sessionStorage.getItem('agentData'));
  }, []);

  return {
    leadsPlusAgent,
    setLeadsPlusAgent,
    setLeadsPlusAgentToSessionStorage: setDataToSessionStorage,
    getLeadsPlusAgentFromSessionStorage: getDataFromSessionStorage
  };
}
